import api from '@/api'

const { $academic, $pricing } = api;

export const { $careers, $courses, $extracurricularCourses, $terms } = $academic;
export const { $prices, $products, $types, $zones, $details, $reindex, $course} = $pricing;